/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import "@ant-design/v5-patch-for-react-19"; // React 19 패치 적용
import { AlertProps, AuthLayoutProps, AuthList, AuthStorage, LayoutProps, MenuProps } from "@/components/layout/layoutType";
import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useInsertionEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";

import Header from "@/components/layout/header/header";
import Tool from "@/components/layout/header/tool";
import Footer from "@/components/layout/footer/footer";

import Default from "@/components/page/default";
import Alert, { AlertHandle } from "@/components/layout/footer/alert";
import { ConfigProvider as AntdConfigProvider, theme as antdTheme, App as AntdApp } from "antd";
import { useTheme } from "next-themes";

import en from "antd/es/date-picker/locale/en_US";
import enUS from "antd/es/locale/en_US";
import ko from "antd/es/date-picker/locale/ko_KR";
import koKR from "antd/es/locale/ko_KR";
import dayjs from "dayjs";
import { checkDebug, Debug } from "@/util/debug";
import "dayjs/locale/ko";
import "dayjs/locale/en";
import updateLocale from "dayjs/plugin/updateLocale";
import buddhistEra from "dayjs/plugin/buddhistEra";
import dayjsAdvancedFormat from "dayjs/plugin/advancedFormat";
import dayjsUtc from "dayjs/plugin/utc";
import dayjsTimezone from "dayjs/plugin/timezone";
import dayjsIsoWeek from "dayjs/plugin/isoWeek";
import { IntlError, IntlErrorCode, NextIntlClientProvider, useLocale, useMessages, useTranslations } from "next-intl";
//import { useMessages as useMessagesHook } from "@/app/hook/useMessages";
import Menu, { getMenuProps } from "../common/menu/menu";
import { fetchHost } from "@/util/fetchutil";
import { getUserAuthData, getUserAuthSession } from "@/util/authutil";
import dv from "@datas/default.json";
import { AlertProvider } from "../context/alertContext";
import { getCookie, getDefaultScreenStr } from "@/util/cookies";

import Side from "@/components/layout/side/side";
import Tab from "@/components/layout/tab/tab";
//  import Setting from "@/components/layout/setting/setting";
import { Capacitor } from "@capacitor/core";
import { App as CapacitorApp } from "@capacitor/app";
import {
  appRouterPush,
  getAppSystemBars,
  isAndroidRouter,
  isNativePlatform,
  setAppSystemBars,
  useLinkRouter,
  useSpaRouter,
} from "@/util/apputil";
import { SuppressErrorBoundary } from "../context/SuppressErrorBoundary";
import { isAndroid } from "react-device-detect";
import { usePathname, useRouter } from "next/navigation";
import { defaultLocale, enLocale, koLocale } from "@/i18n/routing";
import { enableScroll } from "@/util/checkMobile";
import { url } from "inspector";
import { checkEmpty } from "@/util/stringutil";
import { checkLoginCommon, loginFailed, loginSuccess } from "../layout/user/signin";
import { appleLoginCommon, appleUrlPath } from "../layout/user/appleLogin";
import { getApiHostname } from "@/util/paramutil";
import { alertLoading } from "../layout/list/defaultType";
import { Keyboard, KeyboardInfo } from "@capacitor/keyboard";
// import dynamic from "next/dynamic";
// const Side = dynamic(() => import("@/components/layout/side/side"), { ssr: false });
// const Tab = dynamic(() => import("@/components/layout/tab/tab"), { ssr: false });
const useServiceWorker = false;
export const registerServiceWorker = (setRegsw: Dispatch<SetStateAction<boolean>>) => {
  Debug("Service Worker 등록 시작:");
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        Debug("Service Worker 등록 성공:", registration);
        setRegsw(true);
      })
      .catch((error) => {
        Debug("Service Worker 등록 실패:", error);
        setRegsw(false);
      });
    window.addEventListener("load", () => {
      Debug("Service Worker load");
    });
  }
};
export const unregisterServiceWorker = async () => {
  const sw = await navigator.serviceWorker.getRegistration();
  if (sw) {
    await sw.unregister();
  }
};

export const intlError = (error: IntlError) => {
  if (error.originalMessage && checkDebug()) {
    if (error.originalMessage.indexOf("Could not resolve `") > -1 && error.originalMessage.indexOf("` in messages") > -1) {
      console.log(error.originalMessage.substring("Could not resolve `".length, error.originalMessage.indexOf("` in messages")));
    } else {
      Debug(error.originalMessage);
    }
  }
};
export const getMessageFallback = (info: { error: IntlError; key: string; namespace?: string }): string => {
  //const path = [info.namespace, info.key].filter((part) => part != null).join(".");
  return `${info.key}`;
  // if (checkDebug()) {
  //   if (info.error.code === IntlErrorCode.MISSING_MESSAGE) {
  //     return info.key;
  //   } else {
  //     return info.key;
  //   }
  // } else {
  //   return ` `;
  // }
};
dayjs.extend(buddhistEra);
dayjs.extend(dayjsAdvancedFormat);
dayjs.extend(dayjsUtc);
dayjs.extend(dayjsTimezone);
dayjs.extend(dayjsIsoWeek);
// ConfigProvider level locale
//Debug(dayjsKr);
dayjs.extend(updateLocale);
// dayjs.updateLocale('ko', {
//   weekStart: 0,
// });
const buddhistKoLocale: typeof ko = {
  ...ko,
  lang: {
    ...ko.lang,
    // fieldQuarterFormat: "YYYY년 Q분기",
    // fieldWeekFormat:"YYYY년 W주차",
    // fieldTimeFormat: "HH시 mm분 ss초",
    // fieldYearFormat: "YYYY년",
    // fieldMonthFormat: "YYYY년 MM월",
    // fieldDateFormat: "YYYY년 MM월 DD일",
    // fieldDateTimeFormat: "YYYY년 MM월 DD일 HH시 mm분 ss초",
    //fieldDateTimeFormat: "YYYY년 MM월 DD일 a hh시 mm분 ss초",
    fieldQuarterFormat: "YYYY년 Q분기",
    fieldWeekFormat: "YYYY년 w주차",
    fieldTimeFormat: "HH:mm:ss",
    fieldYearFormat: "YYYY",
    fieldMonthFormat: "YYYY MM",
    fieldDateFormat: "YYYY-MM-DD",
    fieldDateTimeFormat: "YYYY-MM-DD a hh:mm:ss",
    yearFormat: "YYYY",
    monthPlaceholder: "달 선택",
    yearPlaceholder: "연 선택",
    cellYearFormat: "YYYY",
    shortMonths: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
    shortWeekDays: ["일", "월", "화", "수", "목", "금", "토"],
  },
};
const globalBuddhistKoLocale: typeof koKR = {
  ...koKR,
  DatePicker: {
    ...koKR.DatePicker!,
    //dateFormat: buddhistKoLocale.lang.fieldDateFormat,
    dateTimeFormat: buddhistKoLocale.lang.fieldDateTimeFormat,
    weekFormat: buddhistKoLocale.lang.fieldWeekFormat,
    //quarterFormat: buddhistKoLocale.lang.fieldQuarterFormat,
    lang: buddhistKoLocale.lang,
  },
};
//Debug(dayjsKr);
// Debug(en);
// Debug(ko);
//Debug(globalBuddhistKoLocale);
const AlertContext = createContext<AlertProps>({
  open: false,
  title: undefined,
  description: undefined,
  useCancel: undefined,
  useOk: undefined,
  cancelTitle: undefined,
  okTitle: undefined,
});

export const GetUseAlertContext = () => {
  return useContext(AlertContext);
};

const useSystemColorMode = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    setIsDarkMode(mediaQuery.matches);

    const handleChange = (e: { matches: boolean | ((prevState: boolean) => boolean) }) => {
      setIsDarkMode(e.matches);
    };

    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  return isDarkMode;
};
export default function Main({
  params_s,
  refererurl_s,
  pathname,
  cookies,
  user,
}: {
  params_s?: LayoutProps;
  refererurl_s: string;
  pathname: string;
  cookies?: { menuPosition?: string; screenType?: string; themeType?: string };
  user: {
    user: any | undefined;
    accessToken: string | null;
    accessChange: boolean;
  };
}) {
  const [params, setParams] = useState<LayoutProps | undefined>(params_s);
  const [regsw, setRegsw] = useState(false);
  const [refererurl, setRefererurl] = useState(refererurl_s);
  const [path, setPath] = useState(usePathname() ?? "");
  const router = useRouter();
  const [alertProp, setAlertProp] = useState<AlertProps>({
    open: false,
    title: undefined,
    description: undefined,
    useCancel: undefined,
    useOk: undefined,
    cancelTitle: undefined,
    okTitle: undefined,
  });
  const alertContext = useContext(AlertContext);

  if (params != null) {
    params.alertFunction = (prop: AlertProps) => {
      setAlertProp(() => {
        return prop;
      });
    };
  }
  const antdLocale = params?.locale === koLocale ? globalBuddhistKoLocale : enUS;
  // useEffect(()=>{

  // },[alertProp])
  dayjs.locale(antdLocale.locale);

  const { defaultAlgorithm, darkAlgorithm } = antdTheme;
  const { theme } = useTheme();
  const isDarkMode = useSystemColorMode();
  const messages = useMessages();
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  // if (params != null) {
  //   params.menu = Menu(refererurl, params);
  //   params.page = params.menu.page;
  //   Debug(`check : ${params.menu.category_id}, ${params.menu.group_id}, ${params.menu.tab_id}`);
  // }

  const [offline, setOffline] = useState(params?.offline ?? false);
  const [menu, setMenu] = useState<MenuProps>(Menu(refererurl, params));
  const [page, setPage] = useState<any>(menu.page);
  const initUserAuth = () => {
    const initMenu = menu; //Menu(refererurl, params);
    const temp_auth: AuthLayoutProps = {};
    if (initMenu.page?.auth && user.user) {
      Object.keys(initMenu.page.auth).forEach((key) => {
        const temp_user_auth = getUserAuthSession(key);
        if (temp_user_auth && temp_user_auth.list && temp_user_auth.list.length > 0) {
          let temp_select: AuthList | undefined = undefined;
          if (temp_user_auth.select) {
            temp_user_auth.list.some((item) => {
              if (item.auth_seq === temp_user_auth.select) {
                temp_select = item;
                return true;
              }
              return false;
            });
          } else {
            temp_select = temp_user_auth.list[0];
          }
          if (temp_select) {
            temp_auth[key] = { list: temp_user_auth.list, select: temp_select };
          }
        }
      });
    }
    Debug("init auth", menu, temp_auth);
    return temp_auth;
  };
  const [auth, setAuth] = useState<AuthLayoutProps>(() => {
    return menu.page?.auth ? "loading" : undefined; //initUserAuth();
  });
  useInsertionEffect(() => {}, []);
  useLayoutEffect(() => {
    if (auth === undefined) {
      setAuth(initUserAuth());
    }
    setAppSystemBars(undefined, true);

    const messageHandler = (event: MessageEvent) => {
      if (event.data?.type === "systemBars") {
        const vars = event.data.data;
        if (vars) {
          setAppSystemBars(vars);
        }
      }
    };

    const errorHandler = (event: ErrorEvent) => {
      if (event.message?.includes("removeChild")) {
        event.preventDefault();
      }
    };

    const popstateHandler = () => {
      checkPopstate();
    };

    window.addEventListener("message", messageHandler);
    window.addEventListener("error", errorHandler);
    if (useSpaRouter && isAndroidRouter()) {
      window.addEventListener("popstate", popstateHandler);
    }

    return () => {
      window.removeEventListener("message", messageHandler);
      window.removeEventListener("error", errorHandler);
      if (useSpaRouter && isAndroidRouter()) {
        window.removeEventListener("popstate", popstateHandler);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const checkPopstate = () => {
    setPath(window.location.pathname);
  };

  // Debug(cookies);
  const defaultScreen = getDefaultScreenStr();

  const [menuPosition, setMenuPosition] = useState(getCookie("menu") ?? cookies?.menuPosition ?? "L");
  const [screenType, setScreenType] = useState(getCookie("screen") ?? cookies?.screenType ?? defaultScreen);
  const ta = useTranslations("alert");
  const alertRef = useRef<AlertHandle>(null);

  useEffect(() => {
    // setAppSystemBars(undefined, true);
    if (document.body) {
      const isCapacitor = Capacitor.isNativePlatform();
      if (isCapacitor) {
        if (!document.body.classList.contains("App")) {
          document.body.classList.add("App");
        }
        const platform = Capacitor.getPlatform();
        document.body.classList.add(platform);
        if (platform === "ios") {
          if (typeof window !== "undefined") {
            const existing = document.querySelector('meta[name="viewport"]');
            if (existing) {
              existing.remove();
            }
            const meta = document.createElement("meta");
            meta.name = "viewport";
            meta.content = "width=device-width, initial-scale=1.0, maximum-scale=10.0, user-scalable=yes, viewport-fit=cover";
            document.head.appendChild(meta);
          }
        }
      } else {
        document.body.classList.remove("App");
        // document.body.classList.add("App");
      }
    }
    if (document.body && document.body.classList.contains("Loading")) {
      setTimeout(() => {
        document.body.classList.remove("Loading");
      }, 100);
    }
    CapacitorApp.addListener("appUrlOpen", (event) => {
      // Debug("앱이 URL로 열림:", event.url);
      try {
        if (event.url.includes("coffeeinsight://oauth") || event.url.includes("coffeeinsite://oauth")) {
          const url = new URL(event.url);
          const code = url.searchParams.get("code");
          const idToken = url.searchParams.get("id_token");
          const alert_p = alertRef.current?.setProp;
          // Debug("Apple login success:", code);
          // Debug(idToken);
          if (checkEmpty(idToken)) {
            loginFailed(ta, alert_p);
          } else {
            if (alert_p) {
              alert_p(alertLoading);
            }
            appleLoginCommon({
              ta,
              alert_p: alertRef.current?.setProp,
              platform: "android",
              url: getApiHostname() + appleUrlPath,
              loginFn: (getData: any) => {
                // console.log(JSON.stringify(getData));
                // alert(JSON.stringify(getData));
                checkLoginCommon(ta, params?.locale, alert_p, getData);
              },
              code: code ?? "",
              idToken: idToken ?? "",
              firstName: "",
              lastName: "",
            });
          }
          // Next.js API 호출 → 세션 발급
        } else if (useLinkRouter) {
          const url = event.url.substring(window.location.origin.toString().length);
          appRouterPush(router, url);
        } else {
          location.href = event.url;
        }
      } catch (err) {
        Debug("URL 파싱 실패:", err);
      }
    });
    const keyboardWillShow = (info: KeyboardInfo) => {
      document.body.classList.add("Keyboard");
    };
    const keyboardWillHide = () => {
      document.body.classList.remove("Keyboard");
    };
    if (Capacitor.isNativePlatform()) {
      Keyboard.addListener("keyboardWillShow", keyboardWillShow);
      Keyboard.addListener("keyboardWillHide", keyboardWillHide);
    }

    if (!regsw && useServiceWorker) {
      registerServiceWorker(setRegsw);
    }
    return () => {
      CapacitorApp.removeAllListeners();
      if (Capacitor.isNativePlatform()) {
        Keyboard.removeAllListeners();
      }
      if (regsw) {
        unregisterServiceWorker();
      }
    };
  }, []);

  useEffect(() => {
    if (navigator) {
      setOffline(!navigator.onLine);
    }
    if (isAndroidRouter()) {
      const menuProps = getMenuProps(path, params?.user);
      // Debug("menuProps", window.location.pathname, menuProps);
      if (menu.category_id !== menuProps.category_id || menu.group_id !== menuProps.group_id || menu.tab_id !== menuProps.tab_id) {
        if (params) {
          const changeParam = {
            ...params,
            locale: menuProps.locale ?? defaultLocale,
            category_id: menuProps.category_id ?? "",
            group_id: menuProps.group_id ?? "",
            tab_id: menuProps.tab_id ?? "",
          };
          if (menu.pathname) {
            setRefererurl(menu.pathname);
          }
          // Debug("changeParam", window.location.pathname, changeParam);
          if (alertRef.current?.setProp) {
            alertRef.current?.setProp({ open: false, loading: false });
          }
          setParams(changeParam);
          enableScroll();
        }
      } else {
        // Debug("menu not change", menu, menuProps);
      }
    }
  }, [path]);

  useEffect(() => {
    if (params != null) {
      // Debug("params 변경 시작");
      const change_menu = Menu(refererurl, params);
      const auth_list: string[] = [];
      const user_auth: Record<string, AuthStorage> = {};
      const now = new Date();
      const userseq: number | undefined = user.user ? user.user.userseq : undefined;
      const setMenuPage = () => {
        const temp_auth: AuthLayoutProps = {};
        const user_auth_keys = Object.keys(user_auth);
        user_auth_keys.forEach((key) => {
          const temp_user_auth = user_auth[key];
          if (temp_user_auth.list && temp_user_auth.list.length > 0) {
            let temp_select: AuthList | undefined = undefined;
            if (temp_user_auth.select) {
              temp_user_auth.list.some((item) => {
                if (item.auth_seq === user_auth[key].select) {
                  temp_select = item;
                  return true;
                }
                return false;
              });
            } else {
              temp_select = temp_user_auth.list[0];
            }
            if (temp_select) {
              temp_auth[key] = { list: temp_user_auth.list, select: temp_select };
            }
          }
        });
        setMenu(change_menu);
        setPage(change_menu.page);
        if (Object.keys(temp_auth).length > 0) {
          setAuth(temp_auth);
        } else {
          setAuth(undefined);
        }
      };
      if (change_menu.page?.auth && user.user) {
        const cacheTerm = process.env.NEXT_PUBLIC_CACHE_TERM_LOW; //LOW
        const checkTerm = cacheTerm ? Number(cacheTerm) : 3600000;
        const auth_keys = Object.keys(change_menu.page.auth);
        auth_keys.forEach((key) => {
          let refresh = true;
          const temp_auth = getUserAuthSession(key);
          if (temp_auth) {
            if (temp_auth.user === userseq) {
              user_auth[key] = temp_auth;
              if (temp_auth.access_at) {
                const checkDate = new Date(temp_auth.access_at).valueOf() + checkTerm;
                if (checkDate > now.valueOf()) {
                  refresh = false;
                }
              }
            } else {
              if (sessionStorage !== undefined) {
                sessionStorage.removeItem(key + "_auth");
              }
            }
          }
          if (refresh) {
            auth_list.push(key);
          }
        });
      }

      if (userseq && auth_list.length > 0) {
        if (Object.keys(user_auth).length > 0) {
          setMenuPage();
        }
        if (navigator.onLine) {
          getUserAuthData(auth_list, userseq, user_auth, now, (data: any) => {
            if (data.change) {
              setMenuPage();
            }
          });
        }
      } else {
        setMenuPage();
      }
      //Debug(`check : ${menu.category_id}, ${menu.group_id}, ${menu.tab_id}`);
    } else {
      Debug("params is null");
    }
  }, [refererurl, params, user.user]);

  const mergeParams: LayoutProps | undefined = params ? { ...params, offline, menu, page, auth } : undefined;
  const locale = useLocale();

  // Debug(theme, cookies?.themeType);
  // Debug("menu obj", menu);
  // Debug("params", params, locale);
  //const messages = useMessagesHook(locale);
  // Debug("user", user, offline);
  return (
    <NextIntlClientProvider
      timeZone={tz ?? "UTC"}
      locale={locale}
      messages={messages}
      onError={intlError}
      getMessageFallback={getMessageFallback}
    >
      <AntdConfigProvider
        locale={antdLocale}
        theme={{
          cssVar: true,
          hashed: true,
          algorithm: theme === "dark" || (theme === "system" && isDarkMode) ? darkAlgorithm : defaultAlgorithm,
          token:
            theme === "dark" || (theme === "system" && isDarkMode)
              ? {
                  colorPrimary: "#b28e6e",
                  colorInfo: "#7c5f46",
                  colorSuccess: "#dca77a",
                  colorWarning: "#fbbb8a24",
                  colorError: "#ffc18cb3",
                }
              : {
                  colorPrimary: "#cea37e",
                  colorInfo: "#dca77a",
                  colorSuccess: "#a07553",
                  colorWarning: "#9b4a0026",
                  colorError: "#723300ac",
                },
        }}
      >
        <AlertProvider>
          <AntdApp className="flex flex-col">
            <Header className="mainHeader mainFlex" pathname={pathname} params={mergeParams} />
            <Tool
              props={{ className: "mainTool" }}
              params={mergeParams}
              cookies={{ ...cookies, menuPosition, screenType, setMenuPosition, setScreenType }}
              user={user}
            />
            <main className="mainGroup mainFlex flex flex-col lg:flex-row relative items-start mx-auto w-full max-w-7xl min-h-[calc(100dvh-9.55rem)] md:min-h-[calc(100dvh-10.25rem)] lg:min-h-[calc(100dvh-11.3rem)] bg-[var(--color-background)]">
              <Side className="lg:min-h-[calc(100dvh-11.3rem)] lg:p-4" refererurl={refererurl} pathname={pathname} params={mergeParams} />
              <div className="lg:min-h-[calc(100dvh-11.3rem)] flex flex-col px-4 py-0 md:py-2 lg:py-4 main-contents screenAnimation">
                <div className="mainTab order-1">
                  <Tab className="mainTabNav screenAnimation" refererurl={refererurl} pathname={pathname} params={mergeParams} />
                </div>
                <div className="mainContents order-2 flex flex-grow max-w-full">
                  <Default params={mergeParams} />
                </div>
              </div>
              {/* <Setting className="lg:min-h-[calc(100dvh-11.3rem)] p-4" /> */}
            </main>
            <Footer className="mainFooter mainFlex" />
            <div className="adsPannel"></div>
            <Alert ref={alertRef} {...alertProp} />
          </AntdApp>
        </AlertProvider>
      </AntdConfigProvider>
    </NextIntlClientProvider>
  );
}
